import React from 'react';
import { motion } from 'framer-motion';
const companies = [{
  name: 'Sinclair Development',
  tagline: 'Sinclair Develops.',
  role: 'Development, ownership and investment'
}, {
  name: 'Sinclair Custom Homes',
  tagline: 'Sinclair Builds.',
  role: 'Construction'
}, {
  name: 'Sinclair Cabinets',
  tagline: 'Sinclair Crafts.',
  role: 'Millwork and finish craft'
}];
export function BrandFamily() {
  return <section className="py-24 px-6 md:px-10 bg-gray-50" data-id="element-22" data-mp="ftq1rb02me08">
      <div className="max-w-7xl mx-auto" data-id="element-23" data-mp="kpx12kxyor97">
        <div className="max-w-3xl mb-16" data-id="element-24" data-mp="ksswa1ifd1ty">
          <p className="text-[#C5A55A] text-xs tracking-[0.3em] uppercase mb-4" data-id="element-25" data-mp="pp9vbqr5x0lt">
            One family of companies
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-black" data-id="element-26" data-mp="ts6at8leoglj">
            We Develop. We Build. We Craft.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-27" data-mp="2569zbz985cj7">
          {companies.map((company, index) => <motion.div key={company.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col bg-white p-10 border-t-2 border-[#C5A55A]" data-id="element-28" data-mp="1pq6e8sk8mzbz" data-mpi={index}>
              <h3 className="text-sm tracking-[0.2em] uppercase text-gray-500 mb-4" data-id="element-29" data-mp="16slrbr11aau0">
                {company.name}
              </h3>
              <p className="text-2xl md:text-3xl font-serif font-bold text-black mb-4" data-id="element-30" data-mp="x0g1ony985hz">
                {company.tagline}
              </p>
              <p className="text-gray-600 mt-auto" data-id="element-31" data-mp="s3h9iay5i8mf">{company.role}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}